import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API } from "../data/site";

export const useSettings = () => {
  const { data } = useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await axios.get(`${API}/settings`)).data,
    staleTime: 60000,
  });
  return data || {};
};

export const useContent = () => {
  const { data } = useQuery({
    queryKey: ["content"],
    queryFn: async () => (await axios.get(`${API}/content`)).data,
    staleTime: 60000,
  });
  const map = data || {};
  return (key, fallback = "") => map[key] || fallback;
};

export const useServiceAreas = () => {
  const { data } = useQuery({
    queryKey: ["service-areas"],
    queryFn: async () => (await axios.get(`${API}/service-areas`)).data,
    staleTime: 60000,
  });
  return data || [];
};

export const useTestimonials = () => {
  const { data } = useQuery({
    queryKey: ["testimonials"],
    queryFn: async () => (await axios.get(`${API}/testimonials`)).data,
    staleTime: 60000,
  });
  return data || [];
};

export const useProjects = () => {
  const { data } = useQuery({
    queryKey: ["projects"],
    queryFn: async () => (await axios.get(`${API}/projects`)).data,
    staleTime: 60000,
  });
  return data || [];
};

export const useSeo = () => {
  const { data } = useQuery({
    queryKey: ["seo"],
    queryFn: async () => (await axios.get(`${API}/seo`)).data,
    staleTime: 60000,
  });
  return data || [];
};
